import { render } from "./Kecamatan.vue?vue&type=template&id=4963547a"
import script from "./Kecamatan.vue?vue&type=script&lang=js"
export * from "./Kecamatan.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__